import { Component, Input, OnInit, Output, EventEmitter, OnDestroy, AfterContentChecked } from '@angular/core';
import { FormGroup, UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import {Subject, Subscription} from 'rxjs';
import { UsuarioService } from '@account/usuario.service';
import { CalculosService } from '@shared/calculos.service';
import { ErrorModel } from '@shared/models/ErrorModel';
import { Abastecedora } from '@shared/models/stock/Abastecedora';
import { Medicion } from '@shared/models/stock/Medicion';
import { Tanque } from '@shared/models/stock/Tanque';
import { MessageService } from '@shell/message.service';
import { MedicionesService } from '../../../mediciones.service';
import { StockService } from '../../../stock.service';
import { Producto } from '@shared/models/abm/Producto';
import { ProductoService } from '@abm/producto/producto.service';
import { SharedService } from '@shared/shared.service';
import { ChangeDetectorRef } from '@angular/core';
import { isNumber } from 'highcharts';
import { TipoContenedor } from '@shared/enums/tipoContenedor';
import { Aeroplanta } from '@shared/models/cierreTurno/Aeroplanta';
import { CierreTurnoService } from '@cierreTurno/cierre-turno.service';

@Component({
  selector: 'app-mediciones-masivas',
  templateUrl: './mediciones-masivas.component.html',
  styleUrls: ['./mediciones-masivas.component.css']
})
export class MedicionesMasivasComponent implements OnInit, AfterContentChecked, OnDestroy {
  @Input() tanques: Tanque[];
  @Input() abastecedoras: Abastecedora[];
  @Output() cancelado: EventEmitter<boolean> = new EventEmitter();

  esValidaDensidad: boolean = true;
  esDensidadMinTanque: any[]=[];
  esDensidadMaxTanque: any[]=[];
  esDensidadMinAbast: any[]=[];
  esDensidadMaxAbast: any[]=[];
  cadenaTanqueDensidad: string[]=[];
  cadenaAbastecedoraDensidad: string[]=[];
  codigoTanques: string[]=[];
  medicionesRecibidas: Medicion[]=[];
  mostrarMensajeAlertaVarillado: boolean = false;
  mensajeAlertaTemperatura: boolean = false;
  mensajeAlertaNivelAgua: boolean = false;
  tanqueGraduacion: boolean = false;
  selectedIndex: number | null = null;
  modelDesde: NgbDateStruct;
  calculandoCantidadNeta: boolean = false;
  medicionesParaTanque: boolean = false;
  guardandoMediciones: boolean = false;
  productos: Producto[]=[];
  fechaLimite = new Date();
  tablaTanques: UntypedFormGroup;
  horaCarga: UntypedFormControl;
  fechaProvisorio: UntypedFormControl;
  obteniendoMediciones: boolean = false;
  aeroplantaActual: string;
  aeroplanta: Aeroplanta;
  change$: Subscription;
  aprobado: boolean = false;
  pastedText: string;
  tablaAbastecedora: UntypedFormGroup;
  readonly entidadesTotales = 2;
  entidadesDescargadas: number = 0;
  private count = new Subject<number>();
  count$: Subscription;
  TipoContenedor = TipoContenedor;

  constructor(
    private fb: UntypedFormBuilder,
    private stockService: StockService,
    private usuarioService: UsuarioService,
    private messageService: MessageService,
    private sharedService: SharedService,
    private productoService: ProductoService,
    private medicionesService: MedicionesService,
    private cdref: ChangeDetectorRef,
    private calculoService: CalculosService, 
    private cierreService: CierreTurnoService) {
      this.change$ = sharedService.aeroplantaSeleccionada.subscribe(()=>{
        this.cancelado.emit(true);
      });
      this.count$ = this.count.subscribe(() => {
        if (this.entidadesDescargadas == this.entidadesTotales)
            this.obteniendoMediciones = false;
      });
      this.tablaTanques = this.fb.group({
        tanques: new UntypedFormArray([]),
        hora: new UntypedFormArray([])
      });
      this.tablaAbastecedora = this.fb.group({
        abastecedoras: new UntypedFormArray([]),
        horaAbastecedora: new UntypedFormArray([])
      });
  }

  ngOnInit() {
    this.entidadesDescargadas = 0;
    this.obteniendoMediciones = true;
    this.aeroplantaActual = this.usuarioService.getAeroplantaActual().codigoAeroplanta;
    this.getProductos();
    this.getMediciones();

    this.initializeContainers(this.tanques, TipoContenedor.Tanque);
    this.initializeContainers(this.abastecedoras, TipoContenedor.Abastecedora);

    this.setFormControls(this.tablaTanques, this.tanques);
    this.setFormControls(this.tablaAbastecedora, this.abastecedoras);
  }

  initializeContainers(containers: any[], tipoContenedor: TipoContenedor) {
    containers.forEach((container, index) => {
      container.mediciones = new Medicion();
      container.mediciones.codigoContenedor = container.codigo;
      container.mediciones.nombreContenedor = container.nombre;
      container.mediciones.tipoContenedor = tipoContenedor;
      container.mediciones.varillado = 0;
      container.mediciones.nivel = 0;
      container.mediciones.nivelNatural = 0;
      container.mediciones.temperatura = 0;
      container.mediciones.densidad = 0;
      container.mediciones.nivelAgua = 0;
      container.medicionCintelink = false;

      const fecha = new Date();
      container.fechaProvisoria = { day: fecha.getUTCDate(), month: fecha.getUTCMonth() + 1, year: fecha.getFullYear() };
      const horaActual = new Date();
      container.horaCarga = { hour: horaActual.getUTCHours() - 3, minute: horaActual.getMinutes(), second: horaActual.getSeconds() };

      // Cadena de densidad y validación
      const densidad = container.mediciones.densidad.toString();
      if (tipoContenedor===TipoContenedor.Tanque) {
        this.cadenaTanqueDensidad[index] = densidad;
        this.validateDensity(densidad, index, TipoContenedor.Tanque)
      } else {
        this.cadenaAbastecedoraDensidad[index] = densidad;
        this.validateDensity(densidad, index, TipoContenedor.Abastecedora);
      }
    });
  }

  setFormControls(formGroup: FormGroup, containers: any[]) {
    formGroup.setControl('fecha', this.fb.array([]));
    formGroup.setControl('hora', this.fb.array([]));
    containers.forEach((container, i) => {
      const controlFecha = new UntypedFormControl(i === 0);
      controlFecha.setValue(container.fechaProvisoria);
      (formGroup.controls.fecha as UntypedFormArray).push(controlFecha);

      const controlHora = new UntypedFormControl(i === 0);
      controlHora.setValue(container.horaCarga);
      (formGroup.controls.hora as UntypedFormArray).push(controlHora);
    });
  }

  //Se agrega la función ngAfterContentChecked con el fin de evitar cartel de error en consola llamado ExpressionChangedAfterItHasBeenCheckedError
  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }

  ngOnDestroy() {
    this.change$.unsubscribe();
    this.count$.unsubscribe();
  }

  async getMediciones(){
    const aeroplanta = await this.cierreService.getAeroplantas(this.aeroplantaActual);
    if(aeroplanta.obtieneTelemediciones) {
      this.medicionesService.getMedicionesMasivas(this.aeroplantaActual)
      .subscribe(result => {
        this.medicionesRecibidas = result;
        this.medicionesRecibidas.forEach( m => {
          const tanque = this.tanques.find(t => t.codigo===m.codigoTanque);
          if (tanque) {
            tanque.mediciones.nivel = m.nivel;
            tanque.mediciones.nivelNatural = m.nivelNatural;
            tanque.mediciones.temperatura = m.temperatura;
            tanque.mediciones.nivelAgua = m.nivelAgua
            tanque.mediciones.varillado = m.varillado;
            tanque.mediciones.fechaHoraMedicion = m.fechaHoraMedicion;
            tanque.medicionCintelink = true;
          }
        });
        // this.cargarMedicionesRecibidas();
        this.entidadesDescargadas++
        this.count.next();
      }, (error) => {
        this.messageService.showErrorMessage(`Error en el servidor: ${error.message}`);
        this.obteniendoMediciones = false;
      });
    } else this.obteniendoMediciones = false;
  }

  inputModificado(){
    this.messageService.showWarningMessage("Ha modificado un campo original de la telemedición", true);
  }

  onBlurAlertaVarillado() {
    this.selectedIndex = null;
    this.mostrarMensajeAlertaVarillado = false;
  }

  onFocusAlertaVarillado(index: number): void {
    this.selectedIndex = index;
    this.mostrarMensajeAlertaVarillado = true;
  }

  onBlurAlertaTemperatura() {
    this.selectedIndex = null;
    this.mensajeAlertaTemperatura = false;
  }

  onFocusAlertaTemperatura(index: number): void {
    this.selectedIndex = index;
    this.mensajeAlertaTemperatura = true;
  }

  onBlurAlertaNivelAgua() {
    this.selectedIndex = null;
    this.mensajeAlertaNivelAgua = false;
  }

  onFocusAlertaNivelAgua(index: number): void {
    this.selectedIndex = index;
    this.mensajeAlertaNivelAgua = true;
  }

  getProductos() {
    this.productoService.obtenerProductos()
      .subscribe(result => {
        this.productos = result;
        this.tanques.forEach((value, index) => {
          this.validateDensity('0', index, TipoContenedor.Tanque)
          // this.validarDensidadCambios("0", index)
        });
        this.abastecedoras.forEach((value, index) => {
          this.validateDensity('0', index, TipoContenedor.Abastecedora)
          //this.validarDensidadCambiosAbastecedora("0", index)
        });
        this.entidadesDescargadas++
        this.count.next();
      });
  }

  recargarPagina() {
    this.ngOnInit();
  }

  cancelar() {
    this.cancelado.emit(true);
  }

  changeValue(containers: any, property: string, event: any, ) {
    if (containers == null) {
      containers = new Medicion();
    }
    containers[property] = event.target.value;

    if (property == 'varillado') {
      containers.nivelNatural = event.target.value;
    }
  }

  verificarGraduacion(i: number) {
    if (!this.tanques[i].tieneGraduacion) {
      this.tanques[i].mediciones.varillado = 0;
      this.tanqueGraduacion = false;
    } else {
      this.tanques[i].mediciones.varillado = 0;
      this.tanqueGraduacion = true;
    }
    this.tablaTanques.controls.nivelVarilladoFormControl.updateValueAndValidity();
  }

  //Formatea la dendisdad de los tanques
  formatDensidadAbastecedora(event, i: number) {
    if (event.charCode == 8 || event.charCode == 0) return null;

    if (event.charCode >= 48 && event.charCode <= 57) {
      this.cadenaAbastecedoraDensidad[i] = this.sharedService.formatDensidad(event);
      this.abastecedoras[i].mediciones.densidad = Number(this.cadenaAbastecedoraDensidad[i]);
      this.validateDensity(this.cadenaAbastecedoraDensidad[i], i, TipoContenedor.Abastecedora);
      // this.validarDensidadCambiosAbastecedora(this.cadenaAbastecedoraDensidad[i], i);
    }
    this.recalcularVolumen(this.abastecedoras[i]);
    return false;
  }

  onPaste(containers: any, event: ClipboardEvent, i: number, tipoContenedor: TipoContenedor) {
    this.pastedText = event.clipboardData.getData('text');
    containers.densidad = Number(this.pastedText);
    if (!this.validateDensity(this.pastedText, i, tipoContenedor)) {
      if (tipoContenedor===TipoContenedor.Tanque) {
        this.cadenaTanqueDensidad[i] = this.pastedText;
      } else {
        this.cadenaAbastecedoraDensidad[i] = this.pastedText;
      }
      return false;
    }
    else return true;
  }

  formatDensidad(event, i: number) {
    if (event.charCode == 8 || event.charCode == 0) return null;

    if (event.charCode >= 48 && event.charCode <= 57) {
      this.cadenaTanqueDensidad[i] = this.sharedService.formatDensidad(event);
      // this.validarDensidadCambios(this.cadenaTanqueDensidad[i], i);
      this.tanques[i].mediciones.densidad = Number(this.cadenaTanqueDensidad[i]);
    }
    this.recalcularVolumen(this.tanques[i]);
    return false;
  }

  onBlurDensidad(tipoContenedor: TipoContenedor, i: number) {
    this.recalcularVolumen(tipoContenedor===TipoContenedor.Tanque ? this.tanques[i] : this.abastecedoras[i]);
  }

  validarTemperatura(temp: string): boolean {
    const temperatura = parseInt(temp, 10);
    return !isNaN(temperatura) && temperatura >= -50 && temperatura <= 100;
  }

  recalcularVolumenes(t: Tanque, esVarillado: boolean) {
    if (t != null && t.mediciones.varillado.toString() != "" && t.mediciones.densidad.toString() != '' && t.mediciones.temperatura.toString() != '' && t.tieneGraduacion) {
      if(t.medicionCintelink && !esVarillado) return;
      this.medicionesParaTanque = true;
      const tanque = t;
      const varillado = t.mediciones.varillado.toString();
      const dens = t.mediciones.densidad.toString();
      const temp = t.mediciones.temperatura.toString();
      this.calculandoCantidadNeta = true;
      if (tanque != null && varillado != '' && varillado != '0'){
        this.stockService.getConversionLitrosPorVarillado(tanque.codigo, varillado)
          .subscribe(volumenLts => {
            t.mediciones.nivelNatural = parseInt(volumenLts);
            if (dens != "" && temp != "") {
              t.mediciones.nivel = this.calculoService.obtenerCTLNuevo(temp, dens, volumenLts);
            }
            this.calculandoCantidadNeta = false;
          },
            (error) => {
              t.mediciones.nivelNatural = t.mediciones.varillado;
              this.calculandoCantidadNeta = false;
              this.medicionesParaTanque = false;
              this.messageService.showErrorMessage(`Error al recalcular volumen: ${error.message}`);
            });
      }
    }
  }

  recalcularVolumen(obj: Tanque | Abastecedora) {
    const volumenLts = Number(obj.mediciones.nivelNatural);
    const dens = Number(obj.mediciones.densidad);
    const temp = Number(obj.mediciones.temperatura);

    if (volumenLts !== null && volumenLts !== undefined && !isNaN(volumenLts) &&
      dens !== null && dens !== undefined && !isNaN(dens) &&
      temp !== null && temp !== undefined && !isNaN(temp)) {
        obj.mediciones.nivel = this.calculoService.obtenerCTLNuevo(temp, dens, volumenLts);
    }
  }

  recalcularVolumen15Abastecedora(t: Abastecedora) {
    const volumenLts = Number(t.mediciones.varillado);
    const dens = Number(t.mediciones.densidad);
    const temp = Number(t.mediciones.temperatura);

    if (volumenLts != null && dens != null && temp !== null) {
      t.mediciones.nivel = this.calculoService.obtenerCTLNuevo(temp, dens, volumenLts);
    }
  }

  modificoMedicionCintelink(t) {
    if(t.medicionCintelink) t.medicionCintelink = false;
  }

  formatDate(year, month, day, hour, minute): Date {
    return new Date(year + '-' + month.toLocaleString(undefined, { minimumIntegerDigits: 2 }) + '-' + day.toLocaleString(undefined, { minimumIntegerDigits: 2 })
      + 'T' + hour.toLocaleString(undefined, { minimumIntegerDigits: 2 }) + ':' + minute.toLocaleString(undefined, { minimumIntegerDigits: 2 }) + ':00');
  }

  validarMedicion(varillado, nivel, nivelNatural, densidad, temp, nivelAgua){
    if(isNumber(varillado) && isNumber(nivel) && isNumber(nivelNatural) && isNumber(densidad) && isNumber(temp) && isNumber(nivelAgua) &&
         densidad > 0 && temp !== null){
          return true;
        }
    return false;
  }

  guardarMedicionesMasivas() {
    let stringMensaje: string = '';
    let medicionValida: boolean = false;
    this.guardandoMediciones = true;
    const medMasivas: Medicion[] = [];
    this.tanques.forEach((value, index) => {
      const fechaMaxTanque = this.formatDate(this.tanques[index].fechaProvisoria.year, this.tanques[index].fechaProvisoria.month, this.tanques[index].fechaProvisoria.day, this.tanques[index].horaCarga.hour, this.tanques[index].horaCarga.minute);
      //nivel y nivelNatural pueden ser 0 ya que desde backend puede devolver 0
      if (this.tanques[index].mediciones.varillado > 0 && this.tanques[index].mediciones.nivel >= 0 && this.tanques[index].mediciones.nivelNatural >= 0 && this.tanques[index].mediciones.densidad > 0 && this.tanques[index].mediciones.temperatura && !isNaN(this.tanques[index].mediciones.nivelAgua) && this.tanques[index].mediciones.nivelAgua !== null) {
        if (this.validateDensity(this.cadenaTanqueDensidad[index], index, TipoContenedor.Tanque) && this.validarTemperatura(this.tanques[index].mediciones.temperatura.toString()) && fechaMaxTanque.getTime() < new Date().getTime()) {
          this.tanques[index].mediciones.fechaHora = this.formatDate(this.tanques[index].fechaProvisoria.year, this.tanques[index].fechaProvisoria.month, this.tanques[index].fechaProvisoria.day, this.tanques[index].horaCarga.hour - 3, this.tanques[index].horaCarga.minute);
          this.tanques[index].mediciones.varillado = Number(this.tanques[index].mediciones.varillado);
          this.tanques[index].mediciones.nivelNatural = Number(this.tanques[index].mediciones.nivelNatural);
          this.tanques[index].mediciones.nivel = Number(this.tanques[index].mediciones.nivel);
          this.tanques[index].mediciones.temperatura = Number(this.tanques[index].mediciones.temperatura);
          this.tanques[index].mediciones.densidad = Number(this.tanques[index].mediciones.densidad);
          this.tanques[index].mediciones.nivelAgua = Number(this.tanques[index].mediciones.nivelAgua);
          this.tanques[index].mediciones.username = this.usuarioService.getUsernameByName();
          medMasivas.push(this.tanques[index].mediciones);
          medicionValida = true;
        } else {
          stringMensaje += 'El tanque ' + this.tanques[index].codigo + ' tiene errores en su carga. ';
        }
      }else {
        stringMensaje += 'El tanque ' + this.tanques[index].codigo + ' tiene errores en su carga. ';
      }
    });
    this.abastecedoras.forEach((value, index) => {
      const fechaMaxAbastecedora = this.formatDate(this.abastecedoras[index].fechaProvisoria.year, this.abastecedoras[index].fechaProvisoria.month, this.abastecedoras[index].fechaProvisoria.day, this.abastecedoras[index].horaCarga.hour, this.abastecedoras[index].horaCarga.minute);
      if (this.abastecedoras[index].mediciones.varillado > 0 && this.abastecedoras[index].mediciones.nivel > 0 && this.abastecedoras[index].mediciones.nivelNatural > 0 && this.abastecedoras[index].mediciones.densidad > 0 && this.abastecedoras[index].mediciones.temperatura && !isNaN(this.abastecedoras[index].mediciones.nivelAgua)) {
        if (this.validateDensity(this.cadenaAbastecedoraDensidad[index], index, TipoContenedor.Abastecedora) && this.validarTemperatura(this.abastecedoras[index].mediciones.temperatura.toString()) && fechaMaxAbastecedora.getTime() < new Date().getTime()) {
          this.abastecedoras[index].mediciones.fechaHora = this.formatDate(this.abastecedoras[index].fechaProvisoria.year, this.abastecedoras[index].fechaProvisoria.month, this.abastecedoras[index].fechaProvisoria.day, this.abastecedoras[index].horaCarga.hour - 3, this.abastecedoras[index].horaCarga.minute);
          this.abastecedoras[index].mediciones.varillado = Number(this.abastecedoras[index].mediciones.varillado);
          this.abastecedoras[index].mediciones.nivelNatural = Number(this.abastecedoras[index].mediciones.nivelNatural);
          this.abastecedoras[index].mediciones.nivel = Number(this.abastecedoras[index].mediciones.nivel);
          this.abastecedoras[index].mediciones.temperatura = Number(this.abastecedoras[index].mediciones.temperatura);
          this.abastecedoras[index].mediciones.densidad = Number(this.abastecedoras[index].mediciones.densidad);
          this.abastecedoras[index].mediciones.nivelAgua = Number(this.abastecedoras[index].mediciones.nivelAgua);
          this.abastecedoras[index].mediciones.username = this.usuarioService.getUsernameByName();
          medMasivas.push(this.abastecedoras[index].mediciones);
          medicionValida = true;
        } else {
          stringMensaje += 'La abastecedora ' + this.abastecedoras[index].codigo + ' tiene errores en su carga.  ';
        }
      }else {
        stringMensaje += 'La abastecedora ' + this.abastecedoras[index].codigo + ' tiene errores en su carga. ';
      }
    });
    if (medicionValida) {
      if (medMasivas.length > 0) {
        this.medicionesService.crearMedicionesMasivas(medMasivas)
          .subscribe(() => {
            this.messageService.showSuccessMessage('Se crearon las mediciones correctamente.');
            this.guardandoMediciones = false;
            this.cancelado.emit(true);
          },
          (error: ErrorModel) => {
            this.messageService.showErrorMessage(error.message)
            this.guardandoMediciones = false;
          });
      } else {
        this.messageService.showErrorMessage('No hay mediciones para guardar, revise que esten completos los campos.')
        this.guardandoMediciones = false;
      }
    } else {
      this.messageService.showErrorMessage(stringMensaje);
      this.guardandoMediciones = false;
    }
  }

  validateDensity(densidad: string, index: number, tipoContenedor: TipoContenedor) {
    if (densidad){
      const codigoProducto = tipoContenedor===TipoContenedor.Tanque ? this.tanques[index].productoActual.codigoProducto : this.abastecedoras[index].productoActual.codigoProducto;
      const productoSeleccionado = this.productos?.find(element => element.codigoProducto===codigoProducto);
      this.esValidaDensidad = true;
      if (productoSeleccionado) {
        this.esValidaDensidad = (Number(densidad) >= productoSeleccionado.densidadMin && Number(densidad) <= productoSeleccionado.densidadMax);
        if (tipoContenedor == TipoContenedor.Tanque) {
            this.esDensidadMinTanque[index] = productoSeleccionado.densidadMin.toFixed(3);
            this.esDensidadMaxTanque[index] = productoSeleccionado.densidadMax.toFixed(3);
        }
        else {
          this.esDensidadMinAbast[index] = productoSeleccionado.densidadMin.toFixed(3);
          this.esDensidadMaxAbast[index] = productoSeleccionado.densidadMax.toFixed(3);
        }
      }
      return this.esValidaDensidad;
    } else {
      return false;
    }
  }
}
